/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const blockingActionV4NameSchema = z
  .enum([
    'None',
    'ConfirmInternDetails',
    'ConfirmAgreementDetails',
    'MustAcceptOrgTerms',
    'MustAcceptOrgDataPolicy',
  ])
  .describe('Member names of BlockingActionV4.')
